"use strict";

// ES3 safe
var _undefined = void 0;

module.exports = function (value) { return value !== _undefined && value !== null; };



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/type/value/is.js
// module id = ../../../node_modules/type/value/is.js
// module chunks = 1